import {HeadingNode} from '@lexical/rich-text';
import {ListNode,ListItemNode} from '@lexical/list';
import {TableNode,TableRowNode,TableCellNode} from '@lexical/table';
import {HorizontalRuleNode} from '@lexical/react/LexicalHorizontalRuleNode';
import {PageNode} from './PageNode.jsx';
import {BlockTokenNode} from './BlockTokenNode.jsx';
import {ImageNode} from './ImageNode.jsx';
export const EDITOR_NODES=[HeadingNode,ListNode,ListItemNode,TableNode,TableRowNode,TableCellNode,HorizontalRuleNode,PageNode,BlockTokenNode,ImageNode];
